<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Form Configuration</span>
</mat-toolbar> -->
<div class="content" [@routeAnimation]="true">

    <mat-card fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="15px" style="background: #f7f7f7;">

        <mat-tab-group #tabGroup mat-stretch-tabs (selectedTabChange)="openFormConfig()" [selectedIndex]="hasRole('ADMIN|PFTPAPPROVER')? 0: 1">
            <mat-tab [disabled]="!(hasRole('ADMIN|PFTPAPPROVER'))" label=" Plant for Planet"></mat-tab>
            <mat-tab [disabled]="!(hasRole('ADMIN|FOUNDATIONAPPROVER|CITAPPROVER'))" label=" Community Grants"></mat-tab>
            <mat-tab [disabled]="!(hasRole('ADMIN|FOUNDATIONAPPROVER|CITAPPROVER'))" label=" Event Sponsorship"></mat-tab>
            <mat-tab [disabled]="!(hasRole('ADMIN|CITAPPROVER'))" label=" Community Investment"></mat-tab>
            <mat-tab [disabled]="!(hasRole('ADMIN|FOUNDATIONAPPROVER'))" label=" LG&E KU Foundation"></mat-tab>
        </mat-tab-group>

        <mat-card *ngIf="showDetail && hasRole('ADMIN|PFTPAPPROVER|CITAPPROVER|FOUNDATIONAPPROVER')">
            <form class="form-content" [formGroup]="formConfig" class="content" fxLayout="column" fxLayoutGap="15px" enctype="multipart/form-data">
                <div fxLayout="row" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="30px">
                    <div fxLayout="row" fxLayoutGap="30px" fxLayout.sm="column" fxLayout.xs="column">
                        <mat-form-field>
                            <input matInput [min]="minEffdt" [matDatepicker]="picker1" placeholder="Form Open From Date*" formControlName="startDate" [disabled]='false'>
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                            <mat-hint align="end">choose from dropdown ^</mat-hint>
                        </mat-form-field>

                        <mat-form-field>
                            <input matInput [min]="minEffdt" [matDatepicker]="picker2" placeholder="Form Open To Date*" formControlName="endDate" [disabled]='false'>
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                            <mat-hint align="end">choose from dropdown ^</mat-hint>
                        </mat-form-field>
                    </div>
                    <mat-form-field style="flex-grow: 3">
                        <input type="text" placeholder="Form Type:" matInput readonly [value]='formName'>
                    </mat-form-field>

                </div>
                <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="20px">
                    <button mat-raised-button (click)="onSave()" [disabled]="!formConfig.dirty" color="primary">Save</button>
                </div>
            </form>
        </mat-card>
    </mat-card>

</div>